const enrollerType = {
	enroller_admin: "ENROLLER ADMIN",
	agent: "AGENT"
};

export const ENROLLER_TYPE = enrollerType;
